import { createSlice } from '@reduxjs/toolkit';
import { createSliceHook, makeActionCreator } from '../helpers';
import {
  ReaderTasksListFetchAction,
  ReaderTasksListFetchSuccessAction,
  ReaderTasksListSetFiltersAction,
  ReaderTasksListState,
} from './ReaderTasksList.types';
import { ReadingStatus } from '@dynamika-shared/types/readings.types';

export const initialState: ReaderTasksListState = {
  loading: false,
  error: undefined,
  data: null,
  filters: {
    search: '',
    sort: '',
    statuses: [ReadingStatus.READING_PENDING, ReadingStatus.IN_PROGRESS],
  },
};

const { actResolve, actReject, act } =
  makeActionCreator<ReaderTasksListState>();

export const ReaderTasksListSlice = createSlice({
  name: 'readerTasksList',
  initialState,
  reducers: {
    fetchReaderTasksList: act<ReaderTasksListFetchAction['payload']>(
      ({ filters, sort }) => ({
        filters,
        sort,
        loading: true,
        error: undefined,
      })
    ),
    fetchReaderTasksListSuccess:
      actResolve<ReaderTasksListFetchSuccessAction['payload']>('data'),
    fetchReaderTasksListError: actReject(),
    setFilters: (state, action: ReaderTasksListSetFiltersAction) => {
      if (!action.payload.filterQuery) {
        return;
      }
      state.filters = {
        ...state.filters,
        [action.payload.filterQuery]: action.payload.filterValue,
      };
    },
    clear: state => {
      state.loading = false;
      state.error = undefined;
      state.data = null;
      state.filters = initialState.filters;
    },
  },
});

export const {
  fetchReaderTasksList,
  fetchReaderTasksListSuccess,
  fetchReaderTasksListError,
  setFilters,
  clear,
} = ReaderTasksListSlice.actions;

export const actions = {
  ...ReaderTasksListSlice.actions,
};

export const useReaderTasksListSlice = createSliceHook(
  ReaderTasksListSlice.name,
  actions,
  initialState
);
